<script setup lang="ts">
import { useUiStore } from '@/stores/ui'
import { ALERT_BANNER, WARNING_BANNER, SUCCESS_BANNER, CONFIRMATION_BANNER } from '@/utils/colors'

const ui = useUiStore()

const colorClasses: Record<string, string> = {
  error: `${ALERT_BANNER.border} ${ALERT_BANNER.bg} ${ALERT_BANNER.text}`,
  warning: `${WARNING_BANNER.border} ${WARNING_BANNER.bg} ${WARNING_BANNER.textAlt}`,
  success: `${SUCCESS_BANNER.border} ${SUCCESS_BANNER.bg} ${SUCCESS_BANNER.text}`,
  info: `${CONFIRMATION_BANNER.border} ${CONFIRMATION_BANNER.bg} ${CONFIRMATION_BANNER.text}`,
}
</script>

<template>
  <Teleport to="body">
    <div class="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      <TransitionGroup
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="translate-y-2 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-2 opacity-0"
      >
        <div
          v-for="toast in ui.toasts"
          :key="toast.id"
          :class="colorClasses[toast.type]"
          :aria-live="toast.type === 'error' ? 'assertive' : 'polite'"
          :role="toast.type === 'error' ? 'alert' : 'status'"
          class="flex items-center gap-3 rounded-lg border px-4 py-3 text-sm shadow-lg"
        >
          <span class="flex-1">{{ toast.message }}</span>
          <button
            v-if="toast.cta"
            class="shrink-0 whitespace-nowrap font-medium underline underline-offset-2 hover:no-underline"
            @click="toast.cta!.action(); ui.removeToast(toast.id)"
          >
            {{ toast.cta.label }}
          </button>
          <button
            class="shrink-0 opacity-60 hover:opacity-100"
            aria-label="Cerrar"
            @click="ui.removeToast(toast.id)"
          >
            <span class="plutto-icon plutto-icon--outlined text-base">close</span>
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
